if (document.querySelector('[data-drupal-selector]')) {
  (function($, Drupal, drupalSettings) {
    'use strict';
    Drupal.behaviors.scrollToAnchor = {
      attach: function(context, settings) {
        scrollToAnchor();
      }
    };
  })(jQuery, Drupal, drupalSettings);
} else {
  scrollToAnchor();
}

function scrollToAnchor () {
  const anchors = document.querySelectorAll('a[href*="#"]');
  anchors.forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      const blockID = anchor.getAttribute('href').substr(1);
      if (blockID && document.getElementById(blockID) ) {
        e.preventDefault();
        document.getElementById(blockID).scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
}
